import { gql } from '@apollo/client'
import { DXO_EXECUTION } from '../fragments/DXOExecution'

export const GET_DXO_EXECUTION_FOR_USER = gql`
  query GetDXOExecutionForUser($input: DXOExecutionForUserInput!) {
    dxoExecutionForUser(input: $input) {
      results {
        ...DXOExecution
      }
      count
    }
  }
  ${DXO_EXECUTION}
`
